import Icon from '@ant-design/icons'
import type { customIconProps } from './types'

function copyIconSVG(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.70377 0.750007H7.39634C8.18404 0.754314 8.93776 1.07136 9.49169 1.6314C10.0456 2.19144 10.3544 2.9486 10.3501 3.73629V7.36372C10.3544 8.15142 10.0456 8.90857 9.49169 9.46861C8.93776 10.0287 8.18404 10.3457 7.39634 10.35H3.70377C2.91607 10.3457 2.16235 10.0287 1.60842 9.46861C1.05449 8.90857 0.745722 8.15142 0.750054 7.36372V3.73715C0.745494 2.9493 1.05416 2.19193 1.60811 1.63171C2.16207 1.07148 2.91592 0.754314 3.70377 0.750007Z"
        stroke="#828282"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.7504 12.75L8.83897 12.75C11.0235 12.7251 12.7744 10.9343 12.7501 8.74971L12.7501 4.74943"
        stroke="#828282"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default function copyIcon(props: customIconProps) {
  return <Icon component={copyIconSVG} {...props} onClick={props.onClick} />
}
